import { useSyncExternalStore } from 'react'

const CONSULTA = '(min-width: 64rem)'

const suscribir = (cb: () => void) => {
  const mq = window.matchMedia(CONSULTA)
  mq.addEventListener('change', cb)
  return () => {
    mq.removeEventListener('change', cb)
  }
}

/**
 * P03 cambia de forma con el ancho (§8.6): tres columnas encadenadas en
 * escritorio, navegación en profundidad en celular. El corte coincide con el
 * `lg:` de Tailwind.
 */
export function useEsEscritorio(): boolean {
  return useSyncExternalStore(
    suscribir,
    () => window.matchMedia(CONSULTA).matches,
    () => true,
  )
}

const CELULAR = '(max-width: 39.99rem)'

const suscribirCelular = (cb: () => void) => {
  const mq = window.matchMedia(CELULAR)
  mq.addEventListener('change', cb)
  return () => {
    mq.removeEventListener('change', cb)
  }
}

/** Menos de 640 px: el corte `sm:` de Tailwind, el del celular. */
export function useEsCelular(): boolean {
  return useSyncExternalStore(
    suscribirCelular,
    () => window.matchMedia(CELULAR).matches,
    () => false,
  )
}
